import React, { Component } from "react";

class LoadSpinner extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                role="progressbar"
                aria-busy="true"
                aria-live="polite"
                aria-valuetext="Loading..."
                className="loader loader--large loader--block"
            >
                <span />
            </div>
        );
    }
}

export default LoadSpinner;
